
import React from 'react';
import { menuItems } from '../components/menu/menuItems.js';
import MenuCardContainer from '../components/MenuPreview/MenuCardContainer.js';
import BookTableSection from '../components/BookTableSection';
import Footer from '../components/Footer';


function Menu() {
    return (
        <div>
            {/* <img src={url} style={styles.coverPhoto} /> */}
            <h1 style={styles.MenuTitleText}>Menu</h1>
            <div style={styles.snacksContainer}>
            <h2>Snacks</h2>
            <div style={styles.menuItemsContainer}>
                {menuItems.snacks.map((items, index) => <MenuCardContainer items={items} key={index} />)}
            </div>
            </div>
            <div style={styles.coffeeContainer}>
            <h2>Coffee</h2>
            <div style={styles.menuItemsContainer}>
            {menuItems.coffee.map((items, index) => <MenuCardContainer items={items} key={index} />)}

            </div>
            </div>
            <BookTableSection/>
            <Footer/>
        </div>
    );
};

export default Menu;


const styles = {
    coverPhoto: {
        height: 500,
        width: '100%'
    },
    MenuTitleText: {
        paddingTop: '10%',
        paddingLeft: '15%',
        paddingBottom: '5%',
        marginTop: 0,
    },
    snacksContainer: {
        paddingLeft: '15%',
        paddingRight: '15%',
    },
    coffeeContainer: {
        paddingLeft: '15%',
        paddingRight: '15%',
        paddingTop: '5%',
    },
    titleContainer: {
        display: 'flex',

    },
    titleText: {
        alignItems: 'flex-start',
        marginRight: "50%",
    },
    priceText: {
        alignItems: 'flex-end',
        marginLeft: '50%',
    },
    menuItemsContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
    },
    itemsContainer: {
        width: '30%',
        paddingTop: '5%',
        paddingBottom: '5%',
        paddingRight: '2%'
    },
}